var regions = require('./regions.json');

function list() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return regions.filter(function (region) {
    if (opts.public && !region.public) {
      return false;
    }

    return true;
  });
}

function lookup() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (opts.code) {
    return regions.find(function (r) {
      return r.code === opts.code;
    });
  }

  if (opts.name) {
    return regions.find(function (r) {
      return r.name === opts.name;
    });
  }
}

function get(nameOrCode) {
  console.warn(".get() method is deprecated! Use .lookup({ code: '' }) or .lookup({ name: '' }) instead.");
  return nameOrCode.match(/[0-9]$/) ? lookup({
    code: nameOrCode
  }) : lookup({
    name: nameOrCode
  });
}

module.exports = {
  list: list,
  lookup: lookup,
  get: get
};